// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"77c06e55","232":"cbec58e4","690":"7ad90216","737":"6e2cb18c","787":"3ce4cc4d"}[chunkId] + ".chunk.js";
};